@if (directoryNumberRef()?.extension) {
  <div>
    <a href="{{ extensionLink() }}">
      <span id="extension-info" data-automation="extension-info">
        {{ directoryNumberRef()?.extension | telephoneNumberFilter }}
      </span>
    </a>
    @if (didLink) {
      <span>
        <span class="text-info px-1">|</span>
        <a id="did-info" data-automation="did-info" href="{{ didLink }}">
          {{ did | telephoneNumberFilter }}
        </a>
      </span>
    }
    <br />
  </div>
}
